import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useIndicadoresOperacao } from "hooks/useDashboardFinanceiro";
import { formatCount, formatPercentage } from "utils/formatters";
import { DashCard, DashCardHeader, DashCardBody } from "./v2/DashCard";
import DashEmptyState from "./v2/DashEmptyState";

const renderPlaceholderRows = () =>
  Array(3)
    .fill(0)
    .map((_, index) => (
      <tr key={index}>
        <td className="dash-skeleton" style={{ height: 14 }} />
        <td className="dash-skeleton" style={{ height: 14 }} />
        <td className="dash-skeleton" style={{ height: 14 }} />
        <td className="dash-skeleton" style={{ height: 14 }} />
      </tr>
    ));

const CardIndicadoresOperacao = () => {
  const { data, isLoading, error } = useIndicadoresOperacao();

  const isAccessDenied = axios.isAxiosError(error) && error?.response?.status === 403;
  if (isAccessDenied) return null;

  const operadores = data?.operadores ?? [];

  return (
    <DashCard hoverable={false}>
      <DashCardHeader
        icon={faUserShield}
        variant="accent2"
        title="Indicadores de Operação"
        subtitle="Visível apenas para administradores"
        tooltip="Taxa de cancelamento de venda por operador nos últimos 30 dias. Taxas acima da média do time merecem atenção — não são, por si só, prova de irregularidade."
      />
      <DashCardBody flush>
        {isLoading ? (
          <table className="dash-table">
            <tbody>{renderPlaceholderRows()}</tbody>
          </table>
        ) : error ? (
          <DashEmptyState icon={faUserShield} title="Erro ao carregar dados" description="Não foi possível carregar os indicadores de operação." />
        ) : operadores.length === 0 ? (
          <DashEmptyState icon={faUserShield} title="Nenhum dado no período" description="Não há indicadores de operação registrados." />
        ) : (
          <table className="dash-table">
            <thead>
              <tr>
                <th>Operador</th>
                <th className="dash-num">Vendas</th>
                <th className="dash-num">Cancelamentos</th>
                <th className="dash-num">Taxa</th>
              </tr>
            </thead>
            <tbody>
              {operadores.map((op) => (
                <tr key={op.usuarioId}>
                  <td className="dash-table-primary">{op.nome}</td>
                  <td className="dash-num">{formatCount(op.quantidadeVendas)}</td>
                  <td className="dash-num">{formatCount(op.quantidadeCancelamentos)}</td>
                  <td className="dash-num">
                    <span className={`dash-pill ${op.taxaCancelamento > 10 ? "dash-pill--critical" : "dash-pill--neutral"}`}>
                      {formatPercentage(op.taxaCancelamento)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </DashCardBody>
    </DashCard>
  );
};

export default CardIndicadoresOperacao;
